/**
 * Recently visited pages — a small localStorage list, recorded by
 * `ModernMainLayout` (which wraps every page) and read by the Accounting
 * bento launcher.
 *
 * Deliberately client-only: this is a convenience list, not a record. It is
 * keyed by user id so two people sharing a browser profile do not see each
 * other's trail, and every read is guarded — a browser with storage disabled
 * must get an empty list, never an exception on the page that reads it.
 */

const KEY = 'biztimize.recentPages';
const LIMIT = 8;

const storageKey = (userId) => `${KEY}.${userId || 'anon'}`;

export const getRecentPages = (userId) => {
  try {
    const raw = window.localStorage.getItem(storageKey(userId));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed)
      ? parsed.filter(p => p && typeof p.path === 'string' && typeof p.label === 'string')
      : [];
  } catch {
    return [];
  }
};

export const recordRecentPage = (userId, entry) => {
  if (!entry || !entry.path || !entry.label) return;
  try {
    const current = getRecentPages(userId).filter(p => p.path !== entry.path);
    const next = [{ path: entry.path, label: entry.label, at: Date.now() }, ...current].slice(0, LIMIT);
    window.localStorage.setItem(storageKey(userId), JSON.stringify(next));
  } catch {
    /* storage unavailable — the list is a convenience, never a requirement */
  }
};
